import React, {useEffect} from "react";
import Styles from './styles.module.scss';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import CabinetSettingsMain from "../../components/cabinnetSettingsMain";
import CabinetSettingsAvatarModal from "../../components/cabinetSettingsAvatarModal";
import CabinetGoogleAuthenticatorConnectModal from "../../components/cabinetGoogleAuthenticatorConnectModal";



const CabinetSettingsPage = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const authStatus = useSelector(store => store.main.authorizationStatus);

    useEffect(()=>{
        if (!authStatus){
            navigate('/sign-in');
        }
    },[authStatus, navigate])

    useEffect(() => {

    }, [dispatch]);

    return (
        <section className={`${Styles.container}`}>
            <div className={`${Styles.contentWrap}`}>
                <CabinetSettingsMain/>
                <CabinetSettingsAvatarModal/>
                <CabinetGoogleAuthenticatorConnectModal/>
            </div>
        </section>
    );
};

export default CabinetSettingsPage;
